import React from 'react';
import Helmet from 'react-helmet';
import { useConfigContext } from '../../../config-context';
var langauges = [
    'x-default',
    'de',
    'en',
    'es',
    'fr',
    'it',
    'ja',
    'ko',
    'pl',
    'pt',
    'ru',
    'tr',
    'nl',
    'sv',
    'no',
    'da',
    'hi',
    'cs',
];
var langCodeMapper = function (code) {
    var map = {
        en: 'www',
        'x-default': 'www',
    };
    return map[code] || code;
};
export var MarketplaceRouterSeo = function () {
    var _a = useConfigContext(), route = _a.route, metaTagsAggregator = _a.metaTagsAggregator;
    var cleanUrl = encodeURI(route.currentUrl);
    var url = removeParametersFromUrl(cleanUrl);
    if (metaTagsAggregator) {
        metaTagsAggregator.push("<meta data-meta-tags-aggregator=\"true\" property=\"og:url\" content=\"" + cleanUrl + "\" />");
        metaTagsAggregator.push("<link data-meta-tags-aggregator=\"true\" rel=\"canonical\" href=\"" + url + "\" />");
    }
    return (React.createElement(Helmet, null,
        React.createElement("meta", { property: "og:url", content: cleanUrl }),
        React.createElement("link", { rel: "canonical", href: url })));
};
export var removeParametersFromUrl = function (url) {
    if (!url) {
        // tslint:disable-next-line:no-return-undefined
        return undefined;
    }
    var cleanedURL = url.split('?')[0];
    if (cleanedURL.endsWith('/')) {
        cleanedURL = cleanedURL.substring(0, cleanedURL.length - 1);
    }
    return cleanedURL;
};
//# sourceMappingURL=marketplace-router-seo.js.map